
































































































































import Vue from 'vue'
import PersonProperty from '@/types/PersonProperty.interface'
import ScrollPosition from '@/types/components/ScrollPosition.interface'
import { mapGetters } from 'vuex'
import IListTile from '@/types/components/IListTile.interface'
import Person, { Email, Phone } from '@/types/Person.interface'
export default Vue.extend({
    data() {
        return {
            //  The height of the primary content
            contentHeight: window.innerHeight,
            personsMergePlaceholder: {
                content: 'No Duplicate Contacts Found',
                img: 'noCustomers'
            },
            filter: {
                selected: {
                    display: 'Phone',
                    key: 'field',
                    value: 'phone'
                },
                options: [
                    {
                        display: 'Phone',
                        key: 'field',
                        value: 'phone'
                    },
                    {
                        display: 'First & Last Name',
                        key: 'field',
                        value: 'name'
                    },
                    {
                        display: 'Email',
                        key: 'field',
                        value: 'email'
                    }
                ]
            },
            loading: false,
            newPerson: {},
            selectedFields: {},
            selectedDuplicateId: null,
            toolbar: {
                title: 'Merge Contacts',
                left: [
                    {
                        title: 'Back',
                        icon: 'mdi-chevron-left',
                        back: '/settings',
                        permission: 1
                    }
                ]
            }
        }
    },
    mounted() {
        //  Load person properties if not loaded
        if (!this.personProperties) this.$store.dispatch('personPropertiesGet')

        //  Reset filter
        this.$store.commit('personsDuplicatesFilterSet', 'phone')

        //  Refresh IList
        this.$store.dispatch('personsDuplicates', { field: 'phone' })

        //  Calculate the height only on next tick
        this.$nextTick(() => {
            //  Calculate the current content height for initial state
            this.calculateContentHeight()

            //  Add this event listener so we recalculate the height whenever window is resized
            window.addEventListener('resize', this.calculateContentHeight)
        })
    },
    beforeDestroy() {
        //  Unset everything when leaving
        this.$store.commit('personsDuplicatesSet', [])
        this.$store.commit('personsDuplicatesFindSet', null)

        //  Remove our resize event listener
        window.removeEventListener('resize', this.calculateContentHeight)
    },
    computed: {
        ...mapGetters({
            duplicates: 'personsDuplicates',
            duplicatesParams: 'personsDuplicatesParams',
            personsDuplicatesFilter: 'personsDuplicatesFilter',
            personsDuplicatesFind: 'personsDuplicatesFind',
            personProperties: 'personProperties',
            lastPage: 'personsDuplicatesLastPage',
            scrollPositionLeft: 'scrollPositionLeft',
            paginating: 'personsDuplicatesPaginating'
        }),
        // Determines if user is using our app or is on a mobile device accessing us through a browser
        isMobile(): boolean {
            return this.$store.getters.isMobile() || this.$store.getters.isApp
        },
        selectedDuplicate(): Person | Email | Phone {
            //  If duplicates not loaded, return null
            if (!this.selectedDuplicateId || !this.personsDuplicatesFind) return null

            //  Return the duplicate person that matches the selected person in the v-select
            return this.personsDuplicatesFind.find(
                (dupe) => dupe.id === this.selectedDuplicateId
            )
        }
    },
    methods: {
        //  The height of the primary content
        calculateContentHeight(): number {
            //  Get the height of the view
            let body = document.body.clientHeight

            //  Define the toolbars offset
            let toolbars = 70

            //  define the padding offset (accounts for padding on smAndUp)
            let padding = 25

            //  Define the app bottom navbar offset
            let navbar = 15

            //  Subtract the height of our app bar, toolbars, navbar, and padding
            let height = body - (toolbars + padding + navbar)

            //  Return height in pixels
            this.contentHeight = height

            return height
        },
        duplicateContactHelp(): void {
            this.$store.dispatch('dialogOpen', {
                type: 'MESSAGE',
                icon: 'mdi-account-switch',
                color: 'primary',
                title: 'Duplicate Contact(s)',
                text: "Duplicate Contact(s) contain information that exactly matches other existing contacts. Select contact information fields you'd like to merge into a Final Merged Contact."
            })
        },
        duplicatesLine1(dupe: Person | Email | Phone): string {
            //  Grab our current duplicates filter
            const filter = this.personsDuplicatesFilter

            //  Return a different type based on the filter
            const line = {
                phone: () => this.duplicatesLine1Phone(dupe),
                name: () => this.duplicatesLine1Person(dupe),
                email: () => this.duplicatesLine1Email(dupe)
            }

            //  Get our value from line
            const val = line[filter]() || null

            //  Return our value
            return val
        },
        duplicatesLine1Email(dupe: Email): string {
            return dupe.address
        },
        duplicatesLine1Person(dupe: Person): string {
            return `${dupe.name_given} ${dupe.name_family}`
        },
        duplicatesLine1Phone(dupe: Phone): string {
            return this.$options.filters.phone(dupe.msisdn)
        },
        duplicatesLine2(dupe: Person | Email | Phone): string {
            //  Return count of duplicates
            return `(${dupe.count.toString()} duplicates)`
        },
        duplicateSelectText(person: Person): string {
            //  If person has first and last name, return first/last
            if (person.name_given && person.name_family) {
                return `${person.name_given} ${person.name_family}`
            }

            //  Next try full name
            if (person.name_full) {
                return `${person.name_full}`
            }

            //  Then try phone number
            if (person.phone_default) {
                return `${person.phone_default.msisdn}`
            }

            //  Then try email
            if (person.email_default) {
                return `${person.email_default.address}`
            }

            //  Otherwise just return nothing
            return null
        },
        duplicatesTile(): IListTile {
            return {
                line1: (dupe: Person | Email | Phone) => this.duplicatesLine1(dupe),
                line2: (dupe: Person | Email | Phone) => this.duplicatesLine2(dupe),
                callback: (dupe: Person | Email | Phone) => this.showDuplicates(dupe)
            }
        },
        fieldDisabled(property: PersonProperty): boolean {
            //  If the person doesn't have a value for this property, disable the checkbox
            if (!this.selectedDuplicateField(property)) return true

            //  If the property is phone and the filter is phone, we can disable
            if (
                property.name === 'Phone Number' &&
                this.personsDuplicatesFilter === 'phone'
            ) {
                return true
            }

            //  If the property is first/last name and the filter is first/last name, we can disable
            if (
                (property.name === 'First Name' || property.name === 'Last Name') &&
                this.personsDuplicatesFilter === 'name'
            ) {
                return true
            }

            //  If the property is email and the filter is email, we can disable
            if (property.name === 'Email' && this.personsDuplicatesFilter === 'email') {
                return true
            }

            //  Return false
            return false
        },
        fieldSelected(property: PersonProperty): boolean {
            //  If nothing selected yet, return false
            if (!this.selectedFields) return false

            //  If the id on the field is the same as the id on the selected duplicate, return true
            return this.selectedFields[property.field] === this.selectedDuplicateId
        },
        filterChanged(filter) {
            //  Construct params for pagination
            const params = {
                field: filter['value'],
                page: 1
            }

            //  Reset the merged person
            this.newPerson = {}

            //  Reset the selected fields
            this.selectedFields = {}

            //  Reset the selected duplicate
            this.selectedDuplicateId = null

            //  Update new params
            this.$store.commit('personsDuplicatesParamsSet', params)

            //  Set the filter in the store
            this.$store.commit('personsDuplicatesFilterSet', filter['value'])

            //  Reset the duplicates list
            this.$store.commit('personsDuplicatesFindSet', null)

            //  Reset list of duplicate fields
            this.$store.commit('personsDuplicatesSet', [])

            //  Paginate
            this.$store.dispatch('personsDuplicates', params)
        },
        finalContactHelp(): void {
            this.$store.dispatch('dialogOpen', {
                type: 'MESSAGE',
                icon: 'mdi-account-switch',
                color: 'primary',
                title: 'Final Merged Contact',
                text: "This is the final merged result of your Duplicate Contact(s) information. Once merged, your Final Merged Contact information can't be undone."
            })
        },
        ignoreDuplicate(duplicate: Person): void {
            //  Look through all selected fields, set any of them to null if
            //  they are set to the person we are ignoring form the duplicates list.
            //  Also set any of these fields to null on the merged person
            for (const [key, value] of Object.entries(this.selectedFields)) {
                if (value === duplicate.id) {
                    this.$set(this.newPerson, key, null)
                    this.$set(this.selectedFields, key, null)
                }
            }

            //  Filter though our duplicates list and remove the person we are ignoring
            const new_array = this.personsDuplicatesFind.filter(
                (person) => person.id !== duplicate.id
            )

            //  Upate the duplicates list
            this.$store.commit('personsDuplicatesFindSet', new_array)
        },
        async merge(dialog_result: boolean): Promise<void> {
            //  If user selects 'no' on confirm, do nothing
            if (!dialog_result) return

            //  Set our person to have same msisdn as free form
            this.newPerson['phone_mobile.msisdn'] =
                this.newPerson['phone_mobile.free_form_number']

            //  Construct payload params
            const params = {
                person: this.newPerson,
                duplicates: this.personsDuplicatesFind
            }

            //  Start the loading spinner
            this.loading = true

            //  Dispatch the request
            const response = await this.$store.dispatch('personsMerge', params)

            //  Stop the loading spinner
            this.loading = false

            //  If there was an error, return
            if (!response) return

            //  Get a copy of the IList items or create an empty array if none exists
            const duplicates = this.personsDuplicates || []

            //  Find the index of the item to remove
            const index = duplicates.findIndex(
                (dupe) => dupe.id == this.$refs.personsMerge.selectedModel.id
            )

            //  Remove the item
            duplicates.splice(index, 1)

            //  Commit the updated items list
            this.$store.commit('personsDuplicatesSet', duplicates)

            //  Reset the duplicates persons list
            this.$store.commit('personsDuplicatesFindSet', null)

            //  Open success dialog
            await this.$store.dispatch('dialogOpen', {
                type: 'MESSAGE',
                title: 'Merge Complete!',
                color: 'primary',
                icon: 'mdi-account-switch',
                text: 'Your contacts have been merged and any duplicates were deleted.',
                buttonLink: `/contacts?id=${response.new_id}`,
                buttonLinkText: 'View Merged Contact'
            })
        },
        mergeConfirm(): void {
            this.$store.dispatch('dialogOpen', {
                type: 'CONFIRM',
                title: 'Confirm Merge',
                icon: 'mdi-account-switch',
                color: 'primary',
                text: 'A new contact will be created with the fields you selected and all duplicates will be deleted. Are you sure you want to proceed?',
                callback: (dialog_result) => {
                    this.merge(dialog_result)
                }
            })
        },
        //  ANY is a bad return type but this can literally be any property on the person
        newPersonProperty(property: PersonProperty): any {
            //  Return the property on the new person
            return this.newPerson ? this.newPerson[property.field] : null
        },
        newPersonUpdate(bool: boolean, property: PersonProperty): void {
            //  If the checkox is being checked
            if (bool) {
                //  Set the field on the merged person to the field on the currently selected duplicate
                this.$set(
                    this.newPerson,
                    property.field,
                    this.selectedDuplicateField(property)
                )

                //  Mark the field as selected by the selected duplicate's id
                this.$set(this.selectedFields, property.field, this.selectedDuplicateId)
            }

            //  If the checkbox is not bieng checked
            else {
                //  Set this field on the merged person to null
                this.$set(this.newPerson, property.field, null)

                //  Remove the selected status from this field
                this.$set(this.selectedFields, property.field, null)
            }
        },

        //  Paginate the next page of the current filtered list
        paginateCurrentList(): void {
            //  Get current pagination params
            const params = this.params

            //  Determine the next page
            const nextPage = params.page + 1

            //  Determine is the page exists, or we're already at the end of pagination
            const shouldPaginate = nextPage <= this.lastPage

            //  Check if we have search text
            const hasText = this.searchBarText !== null

            //  If we should NOT paginate, do nothing
            if (!shouldPaginate || !hasText) return

            //  Else, update pagination params
            params.page = nextPage

            //  Update new params
            this.$store.commit('personsDuplicatesParamsSet', params)

            //  Paginate the next page
            this.$store.dispatch('personsDuplicates', params)
        },
        selectedDuplicateField(property: PersonProperty): any {
            //  Get the passed field from the selected duplicate
            return window._.get(this.selectedDuplicate, property.field)
        },
        showDuplicates(dupe: Person | Email | Phone): void {
            //  Reset the merged person
            this.newPerson = {}

            //  Reset the selected fields
            this.selectedFields = {}

            //  Reset the selected duplicate
            this.selectedDuplicateId = null

            //  Create request params
            let params = {
                field: this.personsDuplicatesFilter
            }

            //  If filter is phone, set msisdn on request
            if (this.personsDuplicatesFilter === 'phone') {
                params['msisdn'] = dupe['msisdn']
            }

            //  If filter is name, set name_given and name_family on the request
            else if (this.personsDuplicatesFilter === 'name') {
                params['name_given'] = dupe['name_given']
                params['name_family'] = dupe['name_family']
            }

            //  If the filter is email, set the address on the request
            else if (this.personsDuplicatesFilter === 'email') {
                params['address'] = dupe['address']
            }

            //  Dispatch the request to find duplicates with the field
            this.$store.dispatch('personsDuplicatesFind', params)
        }
    },
    watch: {
        personsDuplicatesFind(value): void {
            //  If no value, do nothing
            if (!value || value.length < 1) return

            //  Make the first duplicate in the array the initial selected one
            this.selectedDuplicateId = value[0].id

            //  If the filter is phone, set the phone_mobile.msisdn field on the new person
            if (this.personsDuplicatesFilter === 'phone') {
                this.$set(
                    this.newPerson,
                    'phone_mobile.msisdn',
                    value[0].phone_mobile.msisdn
                )
                return
            }

            //  If the filter is name, set the first and last name on the new person
            if (this.personsDuplicatesFilter === 'name') {
                this.$set(this.newPerson, 'name_given', value[0].name_given)
                this.$set(this.newPerson, 'name_family', value[0].name_family)
                return
            }

            //  If the filter is email, set the email_default.address on the new person
            if (this.personsDuplicatesFilter === 'email') {
                this.$set(
                    this.newPerson,
                    'email_default.address',
                    value[0].email_default.address
                )
                return
            }
        },
        scrollPositionLeft(position: ScrollPosition): void {
            //  If we are NOT paginating AND scroll is at bottom, paginate next page
            if (!this.paginating && position.bottom) this.paginateCurrentList()
        }
    }
})
